/* v24 product lightbox — see component-product-lightbox.css. Public API matches Dawn's modal: show(opener) / hide(). */
if (!customElements.get('product-lightbox')) {
  customElements.define('product-lightbox', class ProductLightbox extends HTMLElement {
    constructor() {
      super();
      this.dialog = this.querySelector('[role="dialog"]');
      this.stage = this.querySelector('[data-plb-stage]');
      this.slides = Array.from(this.querySelectorAll('.plb__slide'));
      this.thumbs = Array.from(this.querySelectorAll('[data-plb-go]'));
      this.counter = this.querySelector('[data-plb-counter]');
      this.index = 0; this.scale = 1; this.tx = 0; this.ty = 0;
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.slides.length < 2) this.classList.add('plb--single');
      this.querySelector('[id^="ModalClose-"]').addEventListener('click', () => this.hide());
      const prev = this.querySelector('[data-plb-prev]'), next = this.querySelector('[data-plb-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((b) => b.addEventListener('click', () => this.go(parseInt(b.dataset.plbGo, 10))));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.hide();
        else if (e.key === 'ArrowLeft') this.go(this.index - 1);
        else if (e.key === 'ArrowRight') this.go(this.index + 1);
      });
      this.bindPointer();
      this.stage.addEventListener('wheel', (e) => { e.preventDefault(); this.zoomBy(e.deltaY < 0 ? 1.25 : 0.8, e.clientX, e.clientY); }, { passive: false });
      this.stage.addEventListener('dblclick', (e) => { e.preventDefault(); this.toggleZoom(e.clientX, e.clientY); });
      this.stage.addEventListener('click', (e) => { if (e.target === this.stage || e.target.classList.contains('plb__slide')) this.hide(); });
    }
    connectedCallback() { if (this.moved) return; this.moved = true; document.body.appendChild(this); }
    show(opener) {
      this.openedBy = opener;
      const id = opener && opener.getAttribute('data-media-id');
      const i = this.slides.findIndex((s) => s.dataset.mediaId === id);
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      this.go(i >= 0 ? i : 0, true);
      if (window.trapFocus) trapFocus(this, this.dialog);
      if (window.pauseAllMedia) pauseAllMedia();
    }
    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.resetZoom();
      document.body.dispatchEvent(new CustomEvent('modalClosed'));
      if (window.removeTrapFocus) removeTrapFocus(this.openedBy);
    }
    go(i, instant) {
      const n = this.slides.length; if (!n) return;
      i = ((i % n) + n) % n;
      this.resetZoom();
      this.slides.forEach((s, k) => { s.classList.toggle('is-active', k === i); s.style.transform = ''; });
      this.thumbs.forEach((b, k) => b.classList.toggle('is-active', k === i));
      const t = this.thumbs[i]; if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: instant || this.reduce ? 'auto' : 'smooth' });
      if (this.counter) this.counter.textContent = (i + 1) + ' / ' + n;
      this.index = i;
      [i - 1, i + 1].forEach((k) => { const s = this.slides[((k % n) + n) % n]; const img = s && s.querySelector('img'); if (img && img.loading === 'lazy') img.loading = 'eager'; });
    }
    get img() { const s = this.slides[this.index]; return s ? s.querySelector('img') : null; }
    applyZoom() {
      const img = this.img; if (!img) return;
      img.style.transform = this.scale > 1 ? `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})` : '';
      this.classList.toggle('plb--zoomed', this.scale > 1);
    }
    resetZoom() { this.scale = 1; this.tx = 0; this.ty = 0; this.applyZoom(); }
    clampPan() {
      const img = this.img; if (!img) return;
      const r = img.getBoundingClientRect(), st = this.stage.getBoundingClientRect();
      // visible picture inside the (object-fit: contain) box, at the current scale
      const nw = img.naturalWidth || r.width, nh = img.naturalHeight || r.height, f = Math.min(r.width / nw, r.height / nh);
      const vw = nw * f, vh = nh * f;
      const maxX = Math.max(0, (vw - st.width) / 2), maxY = Math.max(0, (vh - st.height) / 2);
      this.tx = Math.min(maxX, Math.max(-maxX, this.tx)); this.ty = Math.min(maxY, Math.max(-maxY, this.ty));
    }
    zoomBy(f, cx, cy) {
      const img = this.img; if (!img) return;
      const r = img.getBoundingClientRect(), ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
      const s0 = this.scale, s1 = Math.min(4, Math.max(1, s0 * f)), k = s1 / s0;
      this.tx = this.tx * k - ox * (k - 1); this.ty = this.ty * k - oy * (k - 1); this.scale = s1;
      if (s1 === 1) { this.tx = 0; this.ty = 0; }
      this.clampPan(); this.applyZoom();
    }
    toggleZoom(cx, cy) { this.scale > 1 ? this.resetZoom() : this.zoomBy(2.5, cx, cy); }
    bindPointer() {
      const pts = new Map(); let start = null, pinch = null, moved = false, lastTap = 0;
      const st = this.stage;
      st.addEventListener('pointerdown', (e) => {
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY }); try { st.setPointerCapture(e.pointerId); } catch (err) {}
        if (pts.size === 1) { start = { x: e.clientX, y: e.clientY, tx: this.tx, ty: this.ty, t: Date.now() }; moved = false; this.classList.add('plb--dragging'); }
        if (pts.size === 2) { const [a, b] = Array.from(pts.values()); pinch = { d: Math.hypot(a.x - b.x, a.y - b.y), s: this.scale, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2 }; }
      });
      st.addEventListener('pointermove', (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
        if (pts.size === 2 && pinch) {
          const [a, b] = Array.from(pts.values()); const d = Math.hypot(a.x - b.x, a.y - b.y);
          const target = Math.min(4, Math.max(1, pinch.s * d / pinch.d));
          this.zoomBy(target / this.scale, pinch.cx, pinch.cy); moved = true; return;
        }
        if (pts.size === 1 && start) {
          const dx = e.clientX - start.x, dy = e.clientY - start.y;
          if (Math.abs(dx) > 6 || Math.abs(dy) > 6) moved = true;
          if (this.scale > 1) { this.tx = start.tx + dx; this.ty = start.ty + dy; this.clampPan(); this.applyZoom(); }
          else { const s = this.slides[this.index]; if (s) s.style.transform = `translate(${dx}px, ${Math.max(0, dy)}px)`; }
        }
      });
      const end = (e) => {
        if (!pts.has(e.pointerId)) return;
        pts.delete(e.pointerId);
        if (pts.size === 1) { pinch = null; const p = Array.from(pts.values())[0]; start = { x: p.x, y: p.y, tx: this.tx, ty: this.ty, t: Date.now() }; return; }
        if (pts.size > 0) return;
        this.classList.remove('plb--dragging');
        const s = this.slides[this.index]; if (s) s.style.transform = '';
        if (!start) return;
        const dx = e.clientX - start.x, dy = e.clientY - start.y, dt = Date.now() - start.t;
        if (this.scale === 1 && moved) {
          if (dy > 90 && Math.abs(dx) < 60) { this.hide(); }
          else if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { this.go(this.index + (dx < 0 ? 1 : -1)); }
        } else if (!moved && dt < 300 && e.pointerType === 'touch') {
          const now = Date.now(); if (now - lastTap < 320) { this.toggleZoom(e.clientX, e.clientY); lastTap = 0; } else { lastTap = now; }
        }
        start = null;
      };
      st.addEventListener('pointerup', end); st.addEventListener('pointercancel', end);
    }
  });
}
